var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"d-flex justify-space-between"},[_c('span',[_vm._v("Filtros")]),_c('div',[_c('v-btn',{staticClass:"mx-2",attrs:{"title":"Configurar filtros","color":"primary"},on:{"click":function($event){return _vm.$emit('showFilters')}}},[_c('v-icon',[_vm._v("mdi-cog")])],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }